import axios from 'axios';
import {RESOURCES as reportsResources} from '../fuseInventoryOrdersResourceMap';
import {getGetHeaders} from './serverFunctions';

/**
 * Assemble a query for retrieving Inventory Orders list
 *
 * @param params
 * @returns {string}
 */
export const assembleInventoryOrdersQuery = (params) => {
    let q = '?limit=' + params.limit + '&offset=' + params.offset;
    if (params.sort.id) {
        q += '&sort=' + params.sort.id;
        let order = (params.sort.desc) ? 'desc' : 'asc';
        q += '&order=' + order;
    }
    if (params.search && params.search !== '' && params.searchable.length > 0) {
        params.searchable.forEach((item, idx) => {
            q += '&searchable[]=' + item;
        });
        q += '&search=' + encodeURIComponent(params.search);
    }
    if (params.filterColumn && params.filterValue) {
        q += '&filterColumn=' + params.filterColumn;
        q += '&filterValue=' + encodeURIComponent(params.filterValue);
    }
    return q;
};

/**
 * Post a GET call to update or delete Inventory Order data
 *
 * @param type
 * @param params
 * @returns {Promise<{data: *, type: *, params: *} | {data: *, type: *, params: *}>}
 */
export const postInventoryOrderData = async (type, params) => {
    let resource;
    switch (type) {
        case 'location-submit':
            resource = reportsResources.OrderLocationSubmit.GET_ONE(params);
            break;
        case 'location-delete':
            resource = reportsResources.OrderLocationDelete.GET_ONE(params);
            break;
        case 'product-submit':
            resource = reportsResources.OrderProductSubmit.GET_ONE(params);
            break;
        case 'product-delete':
            resource = reportsResources.OrderProductDelete.GET_ONE(params);
            break;
        case 'product-qty-override':
            resource = reportsResources.OrderProductEditCaseQty.GET_ONE(params);
            break;
        default:
            break;
    }

    return axios({
        method: 'get',
        url: resource.uri,
        headers: getGetHeaders()
    }).then((result) => {
        return {
            type: type,
            params: params,
            data: result
        }
    }).catch((error) => {
        return {
            type: type,
            params: params,
            data: error
        }
    })
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/inventoryOrderFunctions.js